<app-dashboard-box
  [title]="'common.title.water-consumption' | translateSafe"
  icon="water_drop">

  <div box-actions
       class="action-row">
    @if (hasAccess(AccountRole.OPERATOR)) {
      <app-button-icon iconName="download"
                       (click)="goToReports()" />
    }

    <app-time-range-selector
      (rangeSelected)="requestMeasurement($event)" />
  </div>

  <app-chart-mixed
    [data]="waterMeasurementData"
    [options]="waterMeasurementOptions"
    [enableTimeRangeSelector]="true"
    (timeRangeChange)="requestMeasurement($event)" />
</app-dashboard-box>
